module.exports = __webpack_public_path__ + "static/media/file-default.391c2dba.svg";